import React from 'react';
import {connect} from 'react-redux';
import {authShowLogin, authShowRegister, authShowRegisterManual} from '../../actions/creators';
import {registerPost,facebookLogin, onSignUpCheckEmailSubmit} from '../../actions/creators/auth';
import { openPopup } from '../../actions/creators/auth/apple';
import SignUpManual from './SignUpManual';
import { dialogAlert } from '../../actions/creators/dialogs';
import { getFingerprint } from '../../reducers';
import { useRecaptcha } from '../../hooks/useRecaptcha';

interface Props {
  appleLogin: () => void;
  displayAlert: (msg: string) => void;
  facebookLogin: () => void;
  fingerprint: string;
  getToken: (action: string) => Promise<string>;
  onCheckEmailSubmit: (fields) => void;
  registerPost: (fields) => void;
  showLogin: () => void;
  showRegister: () => void;
}

const RegisterPanel: React.FC<Props> = ({
  appleLogin,
  displayAlert,
  facebookLogin,
  fingerprint,
  onCheckEmailSubmit,
  registerPost,
  showLogin,
}) => {
  const [disagree, setDisagree] = React.useState(false);
  const { getToken } = useRecaptcha();

  const onDisagreeChange = () => {
    setDisagree(!disagree);
  };

  const handleAppleLogin = () => {
    if (disagree) {
      showDisagreeAlert();
      return;
    }

    appleLogin();
  };

  const handleFacebookLogin = () => {
    if (disagree) {
      showDisagreeAlert();
      return;
    }

    facebookLogin();
  };

  const handleRegisterPost = (fields) => {
    fields.fingerprint = fingerprint;
    registerPost(fields);
  };

  const checkEmailPost = async (fields) => {
    const tmpFields: { [key: string]: any } = fields;
    tmpFields.captcha = await getToken('submit');
    onCheckEmailSubmit(tmpFields);
  };

  const showDisagreeAlert = () => {
    displayAlert('Debes aceptar las condiciones antes de continuar.');
  };

  return (
    <>
      <SignUpManual
        step="1"
        showRegister={showLogin}
        registerPost={handleRegisterPost}
        checkEmailPost={checkEmailPost}
        onLoginClick={showLogin}
        onDisagreeChange={onDisagreeChange}
        appleLogin={handleAppleLogin}
        facebookLogin={handleFacebookLogin}
      />
    </>
  );
};

const mapStateToProps = state => ({
  manual: state.auth.register === 'manual' || state.auth.register === 'apple',
  apple: state.auth.register === 'apple',
  fingerprint: getFingerprint(state),
});

const mapDispatchToProps = dispatch => ({
  showLogin: () => dispatch(authShowLogin()),
  showRegister: () => dispatch(authShowRegister()),
  showManual: () => dispatch(authShowRegisterManual()),
  registerPost: fields => dispatch(registerPost(fields)),
  onCheckEmailSubmit: fields => dispatch(onSignUpCheckEmailSubmit(fields)),
  facebookLogin: () => dispatch(facebookLogin()),
  appleLogin: () => dispatch(openPopup()),
  displayAlert: msg => dispatch(dialogAlert(msg)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterPanel);